import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=0838f632&"
import script from "./profile.js?vue&type=script&lang=js&"
export * from "./profile.js?vue&type=script&lang=js&"
import style0 from "./Profile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports